import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { RequireCompleteProfile } from "../components/auth/RequireCompleteProfile";
import { RequireSession } from "../components/auth/RequireSession";
import { PlatformAuthProvider } from "../lib/use-platform-auth";
import { AuctionsProvider } from "../contexts/AuctionsContext";
import { LoginPage } from "../pages/auth/LoginPage";
import { ProfileSetupPage } from "../pages/auth/ProfileSetupPage";
import { RootRedirectPage } from "../pages/app/RootRedirectPage";
import { AppLayout } from "../components/AppLayout";
import { BudrunderPage } from "../pages/app/BudrunderPage";
import { MineBudPage } from "../pages/app/MineBudPage";
import { FavoritterPage } from "../pages/app/FavoritterPage";
import { MineKjopPage } from "../pages/app/MineKjopPage";
import { MineAuksjonerPage } from "../pages/app/MineAuksjonerPage";
import { AuctionDetailPage } from "../pages/app/AuctionDetailPage";
import { AuctionFormPage } from "../pages/app/AuctionFormPage";
import { KontoPage } from "../pages/app/KontoPage";
import { ProfilTab } from "../pages/app/konto/ProfilTab";
import { SelskapTab } from "../pages/app/konto/SelskapTab";
import { BrukereTab } from "../pages/app/konto/BrukereTab";
import { VarslerTab } from "../pages/app/konto/VarslerTab";
import { SikkerhetTab } from "../pages/app/konto/SikkerhetTab";

export function AppRouter() {
  return (
    <BrowserRouter>
      <PlatformAuthProvider>
        <Routes>
          <Route path="/auth/login" element={<LoginPage />} />
          <Route element={<RequireSession />}>
            <Route path="/auth/profile-setup" element={<ProfileSetupPage />} />
          </Route>
          <Route element={<RequireCompleteProfile />}>
            <Route path="/" element={<RootRedirectPage />} />
            <Route
              path="/:organizationSlug"
              element={
                <AuctionsProvider>
                  <AppLayout />
                </AuctionsProvider>
              }
            >
              <Route index element={<Navigate to="budrunder" replace />} />
              <Route path="budrunder" element={<BudrunderPage />} />
              <Route path="budrunder/:auctionId" element={<AuctionDetailPage />} />
              <Route path="mine-bud" element={<MineBudPage />} />
              <Route path="favoritter" element={<FavoritterPage />} />
              <Route path="mine-kjop" element={<MineKjopPage />} />
              <Route path="mine-auksjoner" element={<MineAuksjonerPage />} />
              <Route path="mine-auksjoner/ny" element={<AuctionFormPage />} />
              <Route path="mine-auksjoner/:auctionId/rediger" element={<AuctionFormPage />} />
              <Route path="konto" element={<KontoPage />}>
                <Route index element={<Navigate to="profil" replace />} />
                <Route path="profil" element={<ProfilTab />} />
                <Route path="selskap" element={<SelskapTab />} />
                <Route path="brukere" element={<BrukereTab />} />
                <Route path="varsler" element={<VarslerTab />} />
                <Route path="sikkerhet" element={<SikkerhetTab />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </PlatformAuthProvider>
    </BrowserRouter>
  );
}
